import React, { useEffect, useMemo, useState } from 'react';
import { geo } from '../api';
import SearchableSelect from './SearchableSelect';

/**
 * LocalidadSelect — la localidad de un activo, elegida del catálogo de municipios del INE de su
 * provincia (Fase 3b). El servidor la vuelve a validar; esto sólo ofrece las buenas.
 *
 *   · se ENSEÑA el nombre natural («la Pobla de Farnals») y se guarda ese;
 *   · la lista viene ordenada por el literal del INE («Pobla de Farnals, la», entre las P);
 *   · el buscador encuentra por cualquiera de las dos formas (alias = nombre_ine).
 *
 * Una localidad de antes del catálogo (texto libre) se sigue viendo, marcada, para que editar otros
 * campos no la borre sin querer; el servidor no la toca si no cambia.
 *
 * props: provincia, value (nombre), onChange(nombre | ''), disabled
 */

// Una petición por provincia y sesión de la página: la lista no cambia en el día.
const cache = new Map();
function cargar(provincia) {
  if (!cache.has(provincia)) {
    const p = geo.municipios(provincia).catch((e) => { cache.delete(provincia); throw e; });
    cache.set(provincia, p);
  }
  return cache.get(provincia);
}

export default function LocalidadSelect({ provincia, value, onChange, disabled = false }) {
  const [lista, setLista] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let vivo = true;
    setError(null);
    if (!provincia) { setLista([]); return undefined; }
    setCargando(true);
    cargar(provincia)
      .then((filas) => { if (vivo) setLista(Array.isArray(filas) ? filas : []); })
      .catch(() => { if (vivo) { setLista([]); setError('No se pudo cargar la lista de municipios. Reintenta.'); } })
      .finally(() => { if (vivo) setCargando(false); });
    return () => { vivo = false; };
  }, [provincia]);

  const opciones = useMemo(() => {
    const o = lista.map((m) => ({ id: m.nombre, nombre: m.nombre, alias: m.nombre_ine }));
    if (value && !cargando && !o.some((x) => x.id === value)) {
      o.unshift({ id: value, nombre: `${value} (no está en el catálogo del INE)` });
    }
    return o;
  }, [lista, value, cargando]);

  return (
    <div>
      <SearchableSelect
        value={value || ''}
        onChange={(v) => onChange(v)}
        options={opciones}
        loading={cargando}
        disabled={disabled || !provincia}
        placeholder={provincia ? 'Elige la localidad…' : 'Elige antes la provincia'}
      />
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
}
